var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isPartner)?_c('div',{staticClass:"breadcrumb show--smallScreens",class:_vm.normal ? "breadcrumb--normal" : ""},_vm._l((_vm.breadcrumbList),function(breadcrumb,idx){return _c('router-link',{key:idx,staticClass:"breadcrumb-text",attrs:{"to":breadcrumb.link}},[_vm._v(_vm._s(breadcrumb.text))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }